import {useState} from 'react';

/** Public guidance only. No school database, student lookup, permissions or model calls. */
export const entryActions=[
 {label:'올해 자료',query:'공개자료 찾아보기'},
 {label:'계획 준비',query:'계획 초안'},
 {label:'체험 준비',query:'도움받을 일'},
 {label:'학생 찾기',query:'학생 찾기'},
 {label:'검사 운영',query:'검사 운영'},
 {label:'배지 발급',query:'배지 발급'}
];
const publicReferences=[
 {title:'2026 경기진로교육 정책추진 기본계획',authority:'경기도교육청',region:'경기',year:2026,date:'2026-02-06',url:'https://www.goe.go.kr/goe/na/ntt/selectNttInfo.do?mi=10961&nttSn=2339341'},
 {title:'2026 진로교육 추진 계획',authority:'전북특별자치도교육청',region:'전북',year:2026,date:'2026-01-19',url:'https://www.jbe.go.kr/jinro/board/view.jbe?boardId=BBS_0000165&dataSid=993514&menuCd=DOM_000001101002000000&paging=ok&startPage=1'}
] as const;
const outline='교육목표\n\n학생들에게 남기고 싶은 경험\n\n수업·상담·체험 운영 방향\n\n학교에서 협의할 사항\n\n지원받을 일\n';
function kind(query:string){
 if(/자료|지침|공문|정책|공고|교육청|교육부|바뀐|올해.*준비|내년.*준비/.test(query))return 'policy';
 if(/계획|초안|이어\s*쓰/.test(query))return 'plan';
 if(/도움받|지원받|체험|기관|강사/.test(query))return 'support';
 if(/학생|상담|검사|배지|발급|명단|보고서|학급/.test(query))return 'school';
 return 'guide';
}
export function CenterEntryWelcome({query,onConnect,onRequest}:{query:string;onConnect:()=>void;onRequest:(query:string)=>void}){
 const [region,setRegion]=useState('');const [copied,setCopied]=useState('');
 const category=kind(query);
 // Calendar year only for this public catalogue; never selects a school academic year.
 const explicitYears=Array.from(query.matchAll(/\b(20\d{2}|21\d{2})\b/g)).map(m=>Number(m[1]));
 const currentYear=new Date().getFullYear();
 const requestedYear=explicitYears.length===1?explicitYears[0]:/내년|다음\s*학년도/.test(query)?currentYear+1:/작년|지난\s*학년도/.test(query)?currentYear-1:null;
 const references=publicReferences.filter(r=>(requestedYear===null||r.year===requestedYear)&&(!region||r.region===region));
 const heading=category==='policy'?'자료부터 편하게 살펴보세요.':category==='plan'?'계획은 한 문장부터 시작해요.':category==='support'?'혼자 준비하지 않아도 돼요.':category==='school'?'학교를 연결하면 이어갈 수 있어요.':'어떤 일을 시작해볼까요?';
 async function copyOutline(){
  try{if(!navigator.clipboard)throw Error('Clipboard unavailable');await navigator.clipboard.writeText(outline);setCopied('기본 틀을 복사했어요.');}
  catch{setCopied('아래 기본 틀을 펼쳐 직접 복사해 주세요.');}
 }
 return <section className="rs-entry-welcome" aria-label="학교 연결 전 업무 안내">
  <h1>{heading}</h1>
  {category==='policy'?<>
   <p>학교 연결 없이 공개자료를 볼 수 있어요.</p>
   <label className="rs-entry-filter">자료 지역 <select aria-label="공개자료 지역" value={region} onChange={e=>setRegion(e.target.value)}><option value="">전체</option><option value="경기">경기</option><option value="전북">전북</option></select></label>
   {references.map(r=><article key={r.url} className="rs-entry-reference"><small>{r.authority} · {r.date} 게시</small><h2>{r.title}</h2><a href={r.url} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">공식 게시물 열기 ↗</a></article>)}
   {!references.length&&<p>{requestedYear?`${requestedYear}년 자료는 `:'이 지역 자료는 '}현재 공개자료 목록에 등록되어 있지 않아요.</p>}
   <p className="rs-entry-caption">현재 등록된 경기·전북 자료 안내입니다. 실시간 검색이나 학교별 적용 판단은 아닙니다.</p>
   <button className="rs-calm-link" onClick={onConnect}>우리 학교 자료로 이어가기 ↗</button>
  </>:category==='plan'?<>
   <p>올해 학생들에게 남기고 싶은 경험부터 적어보세요. 학교를 연결하면 계획을 저장하고 이어 쓸 수 있어요.</p>
   <button className="rs-calm-action" onClick={onConnect}>학교 연결하고 초안 시작</button>
   <button className="rs-calm-link" onClick={()=>void copyOutline()}>기본 틀 복사</button>
   <details className="rs-entry-outline"><summary>기본 틀 보기</summary><pre>{outline}</pre></details>
   {copied&&<p role="status">{copied}</p>}
   <p className="rs-entry-caption">기본 틀은 빈 작성 서식입니다. 학교 자료 조회나 AI 문서 생성은 실행하지 않았습니다.</p>
  </>:category==='support'?<>
   <p>체험처·강사·이동 지원 중 필요한 도움부터 정리해 보세요.</p>
   <div className="rs-entry-guidance"><h2>기관에 물어볼 내용</h2><p>지원 가능한 대상과 일정, 포함되는 비용, 학교에서 준비할 것부터 확인하면 됩니다.</p></div>
   <button className="rs-calm-action" onClick={onConnect}>학교 협력기관 확인하기</button>
   <p className="rs-entry-caption">준비 안내입니다. 지원기관 검색·문의 발송·접수는 실행하지 않았습니다.</p>
  </>:category==='school'?<>
   <p>학생 기록과 학교 업무는 연결된 학교 안에서만 확인합니다. 먼저 학교를 선택해 주세요.</p>
   <button className="rs-calm-action" onClick={onConnect}>학교 연결</button>
   <button className="rs-calm-link" onClick={()=>onRequest('공개자료 찾아보기')}>공개자료 먼저 보기</button>
  </>:<>
   <p>자료를 찾거나 계획을 준비해 보세요. 학교 정보가 필요한 순간에 연결을 안내할게요.</p>
   <div className="rs-entry-choices">{entryActions.slice(0,3).map(action=><button className="rs-calm-link" key={action.query} onClick={()=>onRequest(action.query)}>{action.label} ↗</button>)}</div>
  </>}
 </section>;
}
